import { useMutation, useQueryClient } from "react-query";
import { SubjectPlanType } from "../../types/SubjectPlan";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { updateSubjectPlan } from "../../services/school/subject/updateSubject";
import { Key_subjectplans } from "../../utils/constants";
import toast from "react-hot-toast";
import { createSubjectPlan } from "../../services/school/subject/createSubject";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useForm } from "react-hook-form";
import { routes } from "../../routes";
import { resetSubjectPlanData } from "../../redux/slices/school/subjectPlan";
import { resetUpdateSubjectData } from "../../redux/slices/school/subject";
import { useGetSubjectsPlansQuery } from "../../hooks/useGetSubjectsQuery";
import { ChevronLeftIcon, EnterIcon, TrashIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TableComponent from "../../components/common/Tables";
import { Lists } from "../../components/common/Lists";
import TextAreaFieldComponent from "../../components/inputs/TextAreafield/TextAreafieldComponent";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateSubjectPlanFormValidation } from "../Subject/CreateSubjectPlanFormValidation";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { resetUpdateCourseSubjectData } from "../../redux/slices/school/courseSubject";

const columnNamesMap: { [key: string]: string } = {
  subject: 'Disciplina',
  objectives: 'Objectivo',
  subjectReferences: 'Referência',
  assessmentCriteria: 'Critérios de avaliação',
};
export const AddSubjectPlan = () => {
  const mutation = useMutation({ mutationFn: createSubjectPlan, mutationKey: 'createSubjectPlan' });
  const courseSubjectData = useSelector((state: RootState) => state.courseSubject);

  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItem, setDeleteItem] = useState<SubjectPlanType | null>(null);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mutationUpdate = useMutation(updateSubjectPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_subjectplans);
      toast.success('item apagado');
    },
    onError: () => {
      toast.error("Erro ao apagar item.")
    }
  });
  const openDeleteDialog = (s: SubjectPlanType) => {
    setDeleteItem(s);
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };
  const handleDelete = (ss: SubjectPlanType) => {
    ss.status = false;
    mutationUpdate.mutateAsync(ss)
  };

  const defaultValues: SubjectPlanType = {
    idSubject: courseSubjectData.idSubject,
    idCourse: courseSubjectData.idCourse,
    status: true,
    description: "",
    objectives: "",
    subjectReferences: "",
    assessmentCriteria: ""
  }
  const { control, handleSubmit, setValue, getValues, formState: { errors }, watch, trigger, reset } = useForm<SubjectPlanType>({
    resolver: yupResolver(CreateSubjectPlanFormValidation),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });
  const { data: subjectPlansData, status, isLoading: isLoadingSubjectPlansData, refetch: refreshLoadingSubjectPlansData } = useGetSubjectsPlansQuery({
    PageSize: 400,
    PageNumber: 1,
    IdSubject: courseSubjectData.idSubject, 
    IdCourse:courseSubjectData.idCourse
  }, { enabled: !!courseSubjectData.idSubject && !!courseSubjectData.idCourse  });

  const handleBack = () => {
    // navigate(routes.coursesSubjects);
    dispatch(resetSubjectPlanData());
    dispatch(resetUpdateSubjectData());
    dispatch(resetUpdateCourseSubjectData());

  }
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Criado!");
        reset();
        refreshLoadingSubjectPlansData();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const options = subjectPlansData?.items.map((ss) => [
    {
      label: 'Excluir',
      onClick: () => openDeleteDialog(ss),
      icon: <TrashIcon />
    }

  ]) || [];

  return (
    <Card>
      <Flex direction="row" gap='6'>
        <Flex direction="column" gap="5" style={{ flex: 1 }}>
          <form onSubmit={onSubmit} noValidate>
            <Flex direction='column' gap='4'>

              <TextAreaFieldComponent
                name="description"
                label='Descrição'
                control={control}
                errors={errors}
                fieldProps={{ placeholder: 'Descrição' }}
                style={{ width: '100%' }}
                required={true}
              />
              <TextAreaFieldComponent
                name="objectives"
                label='Objectivos'
                control={control}
                errors={errors}
                fieldProps={{ placeholder: 'Objectivos' }}
                style={{ width: '100%' }}
                required={true}
              />
              <TextAreaFieldComponent
                name="assessmentCriteria"
                label='Critérios de avaliação'
                control={control}
                errors={errors}
                fieldProps={{ placeholder: 'Critérios de avaliação' }}
                style={{ width: '100%' }}
                required={true}
              />
              <TextAreaFieldComponent
                name="subjectReferences"
                label='Referências'
                control={control}
                errors={errors}
                fieldProps={{ placeholder: 'Referências' }}
                style={{ width: '100%' }}
                required={true}
              />

              <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
                  <ChevronLeftIcon /> voltar
                </Button>
                <Button type="submit" disabled={mutation.isLoading} variant='surface'>
                  {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                  Registar
                </Button>
              </Flex>
            </Flex>
          </form>
        </Flex>
        <Flex direction="column" gap="4" style={{ flex: 1 }}>
          <>
            <Lists
              status={status}
              TableComponent={() => <TableComponent
                columns={Object.keys(columnNamesMap)}
                items={subjectPlansData?.items}
                options={options}
                columnNamesMap={columnNamesMap}
                totalPages={subjectPlansData?.totalPages || 1}
                currentPage={currentPage}
                onPageChange={handlePageChange} />} handleClickCreate={undefined}
            />
            <ConfirmAlertDialog
              open={!!deleteItem}
              onOpenChange={(open) => !open && setDeleteItem(null)}
              title="Esta operação é irreversível"
              item={deleteItem}
              onConfirm={confirmDelete}
              onCancel={() => setDeleteItem(null)}
            />
          </>
        </Flex>
      </Flex>

    </Card>
  )
}
